import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import Ping from '@/common/components/Ping';
import { Colors } from '@/common/colors/colors';
import AdminSearchContact from '@/common/components/adminSearchContact/AdminSearchContact';
import Tickets from './components/ticket/Tickets';
import Logout from '@/common/components/Logout';
import moment from 'moment';
import PopUp from '@/common/components/PopUp';
import OrderSearch from '../../../pages/admin/dashboard/components/orderSearch/OrderSearch';
import LanguagesChanger from '@/common/components/languagesChanger/LanguagesChanger';
import TodoView from './components/todoView/TodoView';
import TextToSpeach from './components/textToSpeach/TextToSpeach';
import CreateForm from '../../../pages/admin/dashboard/components/create/CreateForm';
import Icon from '@/common/components/Icon';
import PageSearch from '@/pages/admin/dashboard/components/pageSearch/PageSearch';
import {
	COPY,
	SEARCH_ICON,
} from '@/pages/admin/dashboard/components/pageSearch/constants/pageSearch.constants';
import { getShortcutLabel } from '@/pages/admin/dashboard/components/pageSearch/helpers/getShortcutLabel';
import { AuthContext } from '@/common/contexts/authContext';


const Wrapper = styled.div`
	height: 80px;
	display: flex;
	align-items: center;
	padding: 0px 10px 0 30px;
`;

const Title = styled.h4`
	font-weight: bold;
	font-size: 22px;
	color: ${Colors.darkBlue};
`;

const FullNameWrapper = styled.div`
	display: flex;
	gap: 4px;
	align-items: center;
	font-weight: bold;
	font-size: 22px;
	color: ${Colors.darkBlue};
	margin-right: 10px;
	flex-shrink: 0;
`;

const UserName = styled.span`
	max-width: 280px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const SearchButton = styled.button`
	display: flex;
	align-items: center;
	gap: 8px;
	align-self: stretch;
	margin-left: -5px;
	padding: 0 8px 0 12px;
	border: 1px solid ${Colors.darkBlue};
	border-radius: 10px;
	background: white;
	color: ${Colors.darkBlue};
	font-size: 14px;
	font-weight: bold;
	cursor: pointer;
`;

const ShortcutHint = styled.span`
	padding: 2px 7px;
	border-radius: 6px;
	background: ${Colors.lightGray};
	color: ${Colors.newGray};
	font-size: 12px;
	font-weight: normal;
`;

const ActionsWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;
const WELCOME_OPTIONS = [
	'Hi! How are you?',
	'Good morning! Have a great day!',
	"Hey there! What's up?",
	'Hello! Nice to meet you.',
	'Good evening! How was your day?',
	'Bonjour ! Comment ça va ?',
	'Salut ! Quoi de neuf ?',
	'Coucou ! Enchanté de te rencontrer.',
	'Bonne journée ! À plus tard !',
	'¡Hola! ¿Cómo estás?',
	'¡Buenos días! Que tengas un buen día.',
	'¡Hola! ¿Qué tal?',
	'¡Hola! Mucho gusto en conocerte.',
	'¡Buenas tardes! ¿Cómo ha sido tu día?',
	'Hallo! Wie geht es dir?',
	"Hey! Wie läuft's?",
	'Grüß Gott! Schön, dich kennenzulernen.',
	'Guten Abend! Wie war dein Tag?',
	'Ciao! Come stai?',
	'Buongiorno! Buona giornata!',
	'Hey! Come va?',
	'Salve! Piacere di conoscerti.',
	'Buonasera! Come è andata la tua giornata?',
	'Сайн байна уу?',
	'Манай талаар их маш ойлгохоор байна уу?',
	'Сайн байцгаана уу?',
	'Сайн уу?',
	'Оройн мэнд хүргэе!',
	'你好！',
	'早上好！祝你有美好的一天！',
	'嘿！最近如何？',
	'你好！很高兴认识你。',
	'晚上好！你今天过得怎么样？',
	'Dobar dan! Kako ste?',
	'Dobro jutro! Ugodan dan!',
	'Bok! Kaj ima?',
	'Zdravo! Drago mi je što smo se upoznali.',
	'Dobra večer! Kako je protekao tvoj dan?',
];

const WELCOME_MESSAGE =
	WELCOME_OPTIONS[Math.floor(Math.random() * WELCOME_OPTIONS.length)];

const InfoBar = () => {
	const { authUser } = useContext(AuthContext);

	const [showNewContact, setShowNewContact] = useState();
	const [showOrderSearch, setShowOrderSearch] = useState();
	const [showPageSearch, setShowPageSearch] = useState(false);
	const [showTextToSpeach, setShowTextToSpeach] = useState();

	const user = authUser;

	const canAccessTodos =
		user.access.includes('GET_ADMIN_TODOS') || user.role === 'ADMIN';

	return (
		<>
			<Wrapper>
				<div style={{ width: '600px' }}>
					<Title>{WELCOME_MESSAGE}</Title>
					<span style={{ fontStyle: 'italic', fontSize: '14px' }}>
						<b style={{ color: Colors.darkBlue }}>{moment().format('dddd')}</b>
						{moment().format(', MMMM YYYY')}
					</span>
				</div>
				<div
					style={{
						display: 'flex',
						gap: '20px',
						width: '100%',
						justifyContent: 'center',
					}}
				>
					<AdminSearchContact />
					<div
						className='animation-scale'
						style={{
							border: `1px solid ${Colors.darkBlue}`,
							borderRadius: '10px',
							width: '35px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							color: Colors.darkBlue,
							cursor: 'pointer',
						}}
					>
						<Icon name='add' onClick={() => setShowNewContact(true)} size={20} />
					</div>
					<div
						className='animation-scale'
						style={{
							border: `1px solid ${Colors.darkBlue}`,
							borderRadius: '10px',
							width: '35px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							color: Colors.darkBlue,
							cursor: 'pointer',
							marginLeft: '-15px',
						}}
					>
						<Icon
							name='truck-fast'
							onClick={() => setShowOrderSearch(true)}
						/>
					</div>
					<SearchButton
						className='animation-scale'
						type='button'
						onClick={() => setShowPageSearch(true)}>
						<Icon name={SEARCH_ICON} size={14} cursor='pointer' />
						{COPY.BUTTON_LABEL}
						<ShortcutHint>{getShortcutLabel()}</ShortcutHint>
					</SearchButton>
				</div>
				<ActionsWrapper>
					<FullNameWrapper>
						<UserName title={authUser?.username}>{authUser?.username}</UserName>
						<Ping />
					</FullNameWrapper>
					{canAccessTodos && <TodoView />}
					<Tickets />
					<LanguagesChanger />
					<Icon
						name='headphones'
						style={{
							color: Colors.darkBlue,
							cursor: 'pointer',
						}}
						onClick={() => setShowTextToSpeach(true)}
					/>
					<Logout />
				</ActionsWrapper>
			</Wrapper>
			{showNewContact && (
				<PopUp padding='10px 20px' setShow={setShowNewContact}>
					<CreateForm />
				</PopUp>
			)}
			<PageSearch show={showPageSearch} setShow={setShowPageSearch} />
			{showTextToSpeach && <TextToSpeach setShow={setShowTextToSpeach} />}
			{showOrderSearch && (
				<PopUp setShow={setShowOrderSearch}>
					<OrderSearch />
				</PopUp>
			)}
		</>
	);
};

export default InfoBar;
